export function hasDisplayValue(value) {
  return value !== null && value !== undefined && String(value).trim() !== "";
}

export function displayValue(value, fallback = "-") {
  return hasDisplayValue(value) ? value : fallback;
}

export function displayNumber(value, options) {
  if (!hasDisplayValue(value)) return "-";
  const number = Number(value);
  return Number.isFinite(number) ? number.toLocaleString("en-US", options) : "-";
}

export function displayPercent(value) {
  const number = displayNumber(value);
  return number === "-" ? number : `${number}%`;
}
